import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  data: {
    mainFilter: "6 Months",
    revenueFilter: "6 Months",
    sessionsFilter: "6 Months",
    purchaseFilter: "6 Months",
    transactionsFilter: "6 Months",
    sessionlengthFilter: "6 Months",
    dashboardSessionFilter: "6 Months",
  },
};

const adminDashboardTimeSelectionSlice = createSlice({
  name: "Save the time range selection",
  initialState,
  reducers: {
    updateTimeSelection(state, action) {
      state.data = action.payload;
    },
    resetSavedTransactionLogsSearchFilter(state) {
      state.data = initialState.data;
    },
  },
});

export const { updateTimeSelection, resetSavedTransactionLogsSearchFilter } = adminDashboardTimeSelectionSlice.actions;
export default adminDashboardTimeSelectionSlice.reducer;
